import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IAlert } from '../interfaces/alert';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  public alertData: BehaviorSubject<{ alert: IAlert, visible: boolean }>;

  constructor() {
    const initialStep: IAlert = {
        width: "35vw",
        draggable: false,
        resizable: false,
        iconColor: "green",
        icon: "bx bxs-info-circle",
        title: "Alerta",
        detail: "Mensaje de alerta",
    };
    this.alertData = new BehaviorSubject<{ alert: IAlert, visible: boolean }>({
      alert: initialStep,
      visible: false
    });
  }

  get init() {
    return this.alertData.asObservable();
  }

  show(alert: IAlert) {
    this.alertData.next({ alert, visible: true });
  }

  close() {
    const currentAlert = this.alertData.value.alert;
    this.alertData.next({ alert: currentAlert, visible: false });
  }
}